export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/service1.54bac454.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};